import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeSubscribeModal } from '../../../store/actions/subscribeModalActions';
// import { NavLink } from 'react-router-dom';
import './subscribeModal.css';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';

const styles = {
  subscribeButton: {
    height: 40,
    margin: 10
  },
  emailInput: {
    height: 3
  },
  modalStyles: {
    width: '300px',
    height: '200px'
  }
};

class SubscribeModal extends Component {
  handleCloseModal = e => {
    e.preventDefault();
    this.props.closeSubscribeModal();
  };

  componentWillReceiveProps(newProps) {
    if (newProps.showModal) {
      setTimeout(function() {
        const script = document.createElement('script');
        script.src = '//mautic.hypepilot.com/form/generate.js?id=1';
        var ref = document.querySelector('.bottom-content');
        script.async = true;

        ref.parentNode.insertBefore(script, ref.nextSibling);
      }, 10);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        id="subscribe-dialog"
        open={this.props.showModal}
        onClose={this.props.handleClose}
        // classes={classes.modalStyles}
        disableAutoFocus={true}
        onBackdropClick={this.handleCloseModal}
        PaperProps={{
          style: {
            minHeight: '400px',
            minWidth: '400px',
            backgroundColor: '#162235',
            padding: '10px'
          }
        }}
      >
        <div className="subscribe-modal">
          <div className="subscribe-container">
            <div className="subscribe-top">
              <div className="logo-container">
                <img className="hype-pilot-logo" src="/images/hplogo.png" />
              </div>
              <div className="medium-header-text">
                Subscribe to our mailing list for updates
              </div>
            </div>
            <div id="bottom-content" className="bottom-content" />
            {/* <div /> */}
          </div>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    showModal: state.subscribeModal.subscribeModalIsOpen
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeSubscribeModal: () => dispatch(closeSubscribeModal())
  };
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SubscribeModal);

// connect(
//   mapStateToProps,
//   mapDispatchToProps,

// );



// WEBPACK FOOTER //
// ./src/components/shared/subscribeModal/subscribeModal.js